import {
  BooleanField,
  DateTimeField,
  NumberField,
  RelationshipFieldMany,
  RelationshipField,
  StringField,
} from "../plugins/Cruxtify/field-types";
import {
  BooleanProperty,
  DateTimeProperty,
  JsonProperty,
  NumberProperty,
  RelationshipProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class Configuration extends ApcCrudModel {
  public static icon = "mdi-cog-outline";
  protected static _typeLabel = "Configuration";
  protected static asProperty = "configuration";
  public static api = {
    path: "configurations",
  };

  protected userIdField = ["user"];
  protected static routeBase = "configurations";

  protected static userPermissions = new UserPermissions(
    {},
    UserPermission.Read
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "user",
        label: "User",
        relatedModel: "User",
        foreignProperty: "configurations",
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "product",
        label: "Product",
        relatedModel: "Product",
        foreignProperty: "configurations",
      },
    },
    {
      type: NumberProperty,
      opts: {
        name: "quantity",
        label: "Quantity",
        default: 1,
        decoratorSuffix: ")",
        decoratorPrefix: "(",
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "quote_requests",
        label: "Quote Requests",
        relatedModel: "QuoteRequest",
        foreignProperty: "configurations",
        computed: true,
      },
    },
    {
      type: JsonProperty,
      opts: {
        name: "configuration_data",
        label: "Configuration Data",
        description: "Selected options for each slot",
        userPermissions: UserPermission.Read,
        default: {},
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    { type: DateTimeField, opts: { property: "created_at" } },
    { type: DateTimeField, opts: { property: "updated_at" } },
    {
      type: RelationshipField,
      opts: { property: "user" },
    },
    {
      type: RelationshipField,
      opts: { property: "product", isPrimaryLabelField: 2 },
    },
    {
      type: NumberField,
      opts: { property: "quantity", isPrimaryLabelField: 1 },
    },
    {
      type: StringField,
      opts: {
        property: "configuration_data",
        viewComponentName: "configuration-data-field",
      },
    },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "quote_requests",
        viewComponentName: "form-relationship-field-many-table",
        formComponentName: "form-relationship-field-many-table",
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["created_at", "product", "user", "quantity"],
      enableSearch: true,
      enableDynamicFilters: true,
      useModal: true,
      dynamicFilterOptions: {
        filterFields: ["product", "user", "created_at", "updated_at"],
      },
      defaultSort: [
        {
          field: "updated_at",
          order: "desc",
        },
      ],
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "FieldSetGridLayout",
      opts: {
        id: "configDetails",
        fieldSets: [
          {
            id: "main",
            fields: ["quantity", "product", "user"],
          },
          {
            id: "data",
            fields: ["configuration_data"],
          },
          {
            id: "quote_requests",
            fields: ["quote_requests"],
          },
          {
            id: "meta",
            fields: ["created_at", "updated_at", "id"],
          },
        ],
      },
    },
  ];
}
